type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: Props) {
  return (
    <div className={`mb-8 md:mb-12 ${align === "center" ? "text-center" : "text-left"}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
        <i className="ri-sparkling-2-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}